import { render, staticRenderFns } from "./CameraDisplay.vue?vue&type=template&id=72956237&scoped=true"
import script from "./CameraDisplay.vue?vue&type=script&lang=js"
export * from "./CameraDisplay.vue?vue&type=script&lang=js"
import style0 from "./CameraDisplay.vue?vue&type=style&index=0&id=72956237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72956237",
  null
  
)

export default component.exports